export default __webpack_public_path__ + "static/media/black_book.9297877e.webp";